// A retired migration route uses only v2. A missing adapter is a retryable failure, never a second backend.
import { ANSWERED_BY, V2_API } from './http.ts'

const unavailable = () =>
  new Response(
    JSON.stringify({
      error: 'This request is temporarily unavailable. Please try again.',
      code: 'unavailable',
      retryable: true,
    }),
    {
      status: 503,
      headers: {
        'Content-Type': 'application/json',
        [ANSWERED_BY]: 'v2',
      },
    },
  )

/** Load the adapter before its one request. An absent API or unavailable module sends nothing. */
export async function requestV2<M>(
  load: () => Promise<M>,
  request: (module: M) => Promise<Response>,
): Promise<Response> {
  if (!V2_API) return unavailable()
  let loaded: M
  try {
    loaded = await load()
  } catch {
    return unavailable()
  }
  return request(loaded)
}
